var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 14.957,
    y: 4.105,
    style: {
      fill: "#F14742"
    },
    width: 287.209,
    height: 492.659
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.802,
    y: 36.949,
    style: {
      fill: "#1B4145"
    },
    width: 221.522,
    height: 164.187
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 158.56,
    cy: 348.956,
    r: 92.697
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F14742"
    },
    cx: 158.56,
    cy: 348.956,
    r: 36.128
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4145"
    },
    d: "M373.877,196.706c-21.465,0-38.865,17.401-38.865,38.865c0,17.083,11.022,31.593,26.344,36.804 h25.041c15.322-5.21,26.345-19.721,26.345-36.805C412.742,214.106,395.343,196.706,373.877,196.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B4145"
    },
    d: "M458.176,104.743c-21.465,0-38.865,17.401-38.865,38.865c0,17.083,11.022,31.593,26.344,36.804 h25.041c15.322-5.21,26.345-19.721,26.345-36.805C497.042,122.143,479.642,104.743,458.176,104.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.36,
    y: 262.128,
    style: {
      fill: "#8B7E7F"
    },
    width: 25.034,
    height: 86.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.66,
    y: 167.614,
    style: {
      fill: "#8B7E7F"
    },
    width: 25.034,
    height: 88.583
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M302.169,0H14.957c-4.536,0-8.211,3.675-8.211,8.211V500.87c0,4.536,3.675,8.211,8.211,8.211h287.212 c4.536,0,8.211-3.675,8.211-8.211V8.211C310.38,3.675,306.703,0,302.169,0z M293.958,492.659H23.168V16.422h270.79V492.659z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.801,213.456h21.896c4.536,0,8.211-3.675,8.211-8.211c0-4.536-3.675-8.211-8.211-8.211H56.012V49.266h205.102v147.768 H102.541c-4.536,0-8.211,3.675-8.211,8.211c0,4.536,3.675,8.211,8.211,8.211h166.784c4.536,0,8.211-3.675,8.211-8.211V41.055 c0-4.536-3.675-8.211-8.211-8.211H47.801c-4.536,0-8.211,3.675-8.211,8.211v164.19C39.59,209.78,43.266,213.456,47.801,213.456z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.563,252.147c-55.641,0-100.909,45.269-100.909,100.91s45.268,100.909,100.909,100.909s100.909-45.268,100.909-100.909 S214.204,252.147,158.563,252.147z M158.563,437.544c-46.586,0-84.487-37.901-84.487-84.487c0-46.587,37.901-84.488,84.487-84.488 s84.487,37.901,84.487,84.488C243.05,399.643,205.149,437.544,158.563,437.544z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.563,308.718c-24.449,0-44.339,19.89-44.339,44.339s19.89,44.339,44.339,44.339s44.339-19.89,44.339-44.339 S183.012,308.718,158.563,308.718z M158.563,380.975c-15.394,0-27.917-12.523-27.917-27.917c0-15.394,12.523-27.917,27.917-27.917 s27.917,12.523,27.917,27.917C186.48,368.451,173.957,380.975,158.563,380.975z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M373.878,192.599c-25.958,0-47.076,21.119-47.076,47.076c0,18.141,10.375,34.452,26.347,42.276v70.32 c0,4.536,3.675,8.211,8.211,8.211h4.307v143.307c0,4.536,3.675,8.211,8.211,8.211s8.211-3.675,8.211-8.211V360.482h4.306 c4.536,0,8.211-3.675,8.211-8.211v-70.32c15.972-7.822,26.348-24.133,26.348-42.275 C420.954,213.718,399.836,192.599,373.878,192.599z M394.561,262.292c-0.425-4.136-3.918-7.361-8.167-7.361 c-4.536,0-8.211,3.675-8.211,8.211v80.919h-8.612v-80.919c0-4.536-3.675-8.211-8.211-8.211c-4.248,0-7.741,3.225-8.167,7.36 c-6.21-5.686-9.97-13.814-9.97-22.615c0-16.903,13.752-30.654,30.654-30.654s30.654,13.752,30.654,30.654 C404.532,248.477,400.772,256.605,394.561,262.292z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M505.254,147.712c0-25.958-21.119-47.076-47.076-47.076c-25.958,0-47.076,21.119-47.076,47.076 c0,18.141,10.375,34.452,26.347,42.276v70.32c0,4.536,3.675,8.211,8.211,8.211h4.307v235.27c0,4.536,3.675,8.211,8.211,8.211 c4.536,0,8.211-3.675,8.211-8.211v-235.27h4.306c4.536,0,8.211-3.675,8.211-8.211v-70.32 C494.877,182.165,505.254,165.854,505.254,147.712z M478.86,170.329c-0.425-4.136-3.918-7.361-8.167-7.361 c-4.536,0-8.211,3.675-8.211,8.211v80.919h-8.612v-80.919c0-4.536-3.675-8.211-8.211-8.211c-4.248,0-7.741,3.225-8.167,7.36 c-6.21-5.686-9.97-13.814-9.97-22.615c0-16.903,13.752-30.654,30.654-30.654s30.654,13.752,30.654,30.654 C488.832,156.513,485.071,164.642,478.86,170.329z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicPlayer);
export default __webpack_public_path__ + "static/media/music-player.7be2d7aecad933319caa8d8323cf7bb2.svg";
export { ForwardRef as ReactComponent };